export default {
  required: 'Please enter',
  requiredSelect: 'Please select',
  basicInfo: 'Basic Info',
  providerType: 'Provider Type',
  providerTypeCustom: 'Custom',
  serverType: 'Server API/SMTP',
  serverTypeAPI: 'API',
  serverTypeSMTP: 'SMTP',
  apiKey: 'API',
  apiKeyPlaceholder: 'Please enter email service API',
  apiSecret: 'API SECRET',
  apiSecretPlaceholder: 'Please enter email service API secret',
  smtpHost: 'Server Address (SMTP)',
  smtpHostPlaceholder: 'Please enter SMTP server address',
  smtpPort: 'Port',
  smtpPortPlaceholder: 'Please enter port (e.g. 457 or 587)',
  encryption: 'Encryption',
  encryptionSSL: 'SSL',
  encryptionTLS: 'TLS',
  encryptionNone: 'None',
  senderPassword: 'Sender Password / Auth Code',
  senderPasswordPlaceholder: 'Please enter authorization password',
  senderEmail: 'Sender Email Address',
  senderEmailPlaceholder: 'Please enter sender email address',
  senderName: 'Sender Username',
  senderNamePlaceholder: 'Please enter sender username',
  sendTest: 'Send Test',
  testRecipient: 'Test Recipient Email',
  testRecipientPlaceholder: 'Please enter recipient email',
  sendTestEmail: 'Send Test Email',
  sendTestSuccess: 'Test email sent successfully',
  sendTestFail: 'Failed to send test email',
  save: 'Save Config',
  saveSuccess: 'Saved successfully',
  tabConfig: 'Email Config',
  tabSendLog: 'Send Log',
  sendLog: 'Email Sending Records',
  logSendTime: 'Send Time',
  logRecipient: 'Recipient',
  logStatus: 'Status',
  logTemplateName: 'Template Name',
};
